<script setup>
import { useI18n } from 'vue-i18n';
defineProps({ order: { type: Object, required: true } });
const { t } = useI18n();
const money = bag => {
  const value = bag?.presentmentMoney;
  if (!value) return '—';
  return new Intl.NumberFormat('en', {
    style: 'currency',
    currency: value.currencyCode,
  }).format(Number(value.amount));
};
</script>

<template>
  <section
    class="flex min-w-0 flex-col gap-3 rounded-xl border border-n-weak p-4"
  >
    <div class="flex flex-wrap items-center gap-2">
      <h3 class="text-lg font-semibold">{{ order.name }}</h3>
      <span
        v-if="order.displayFinancialStatus"
        class="rounded-md bg-n-alpha-2 px-2 py-1 text-xs"
        >{{ order.displayFinancialStatus.replaceAll('_', ' ') }}</span
      >
      <span
        v-if="order.displayFulfillmentStatus"
        class="rounded-md bg-n-alpha-2 px-2 py-1 text-xs"
        >{{ order.displayFulfillmentStatus.replaceAll('_', ' ') }}</span
      >
    </div>
    <div
      class="grid min-w-0 grid-cols-1 gap-3 border-t border-n-weak pt-3 sm:grid-cols-3 [&>div]:flex [&>div]:items-baseline [&>div]:justify-between [&>div]:gap-3 sm:[&>div]:flex-col sm:[&>div]:gap-1 [&_strong]:shrink-0 [&_strong]:tabular-nums"
    >
      <div>
        <p class="text-n-slate-11">{{ t('ORDER_ACTIONS.PAID') }}</p>
        <strong>{{ money(order.totalReceivedSet) }}</strong>
      </div>
      <div>
        <p class="text-n-slate-11">{{ t('ORDER_ACTIONS.ALREADY_REFUNDED') }}</p>
        <strong>{{ money(order.totalRefundedSet) }}</strong>
      </div>
      <div>
        <p class="text-n-slate-11">{{ t('ORDER_ACTIONS.REMAINING') }}</p>
        <strong>{{ money(order.fullRefund?.maximumRefundableSet) }}</strong>
      </div>
    </div>
  </section>
</template>
